import { useState } from 'react'
import { describeError } from '@/lib/auth'
import { Modal } from '../settings/Modal'
import styles from './ConfirmModal.module.css'

interface Props {
  title: string
  text: string
  confirmLabel: string
  onConfirm: () => Promise<void>
  onCancel: () => void
}

/** Подтверждение опасного действия: покинуть, удалить, выгнать, забанить. */
export function ConfirmModal({ title, text, confirmLabel, onConfirm, onCancel }: Props) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const confirm = async () => {
    setBusy(true)
    setError(null)
    try {
      await onConfirm()
    } catch (err) {
      setError(describeError(err).message)
      setBusy(false)
    }
  }
  return (
    <Modal title={title} onClose={onCancel}>
      <p className={styles.text}>{text}</p>
      {error ? <p className={styles.error} role="alert">{error}</p> : null}
      <div className={styles.buttons}>
        <button type="button" className={styles.cancel} onClick={onCancel}>Отмена</button>
        <button type="button" className={styles.confirm} disabled={busy} onClick={() => void confirm()}>{busy ? 'Секунду…' : confirmLabel}</button>
      </div>
    </Modal>
  )
}
